import { Employee } from '../Department/DepartmentTypes';
import { Job, Project } from '../Project/ProjectTypes';

export type ChangeRequest = {
  id: string;
  job: Job & { projects: number[] };
  employee: Employee;
  type: number; // default = 4
  copy_to_project?: Project; // project_id; ignored for types: 0,1,3,4    used in:2
  info?: string; // ignored for types: 0-3                               used in:4
  combine_with?: Job; // job_id; ignored for types: 0,1,2,4           used in:3
  step_number?: number; // ignored for types 1-4                         used in:0
  created_at?: string;
};

export enum ChangeRequestType {
  JOB_STEP_NUMBER = 0,
  DELETE = 1,
  COPY_TO_PROJECT = 2,
  COMBINE_STEPS = 3,
  INFO = 4,
}
